import { biLogger } from '../biLogger';
import { selectBiData } from '../selectors';
import { BiEventLogger } from '../types';
import { getRuntimeDataForBi } from '../utils';

export const logCaraIsOffered: BiEventLogger<{ messageId: string }> = async (state, data) => {
  const biData = selectBiData(state);
  const { sessionId, contextBi } = await getRuntimeDataForBi(state);

  await biLogger.caraIsOffered(state, {
    self_service_session_id: sessionId,
    chatbot_view: contextBi?.chatbot_view,
    conversation_id: biData.conversationId,
    message_id: data.messageId,
  });
};
